// extracted by mini-css-extract-plugin
module.exports = {"overlay":"AlertDialog_overlay__3-ueS"};